import { Box, CircularProgress, Typography } from '@mui/material'
import { BasePathProvider, useBasePath } from 'components/Providers';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import SubstituteTableList from './List/SubstitutesTableList';
// import { capitalize } from 'lodash';
// import jsPDF from 'jspdf';

const SubstituteTable = ({ periods, boxStyles, innerBoxStyles, coveragePeriods }) => {
    const { t } = useTranslation();
    const baseUrl = useBasePath();
    const loading = useSelector(state => state.substitutePortal.substitute.loading)

    return (
        <BasePathProvider value={`${baseUrl}`}>
            <Box sx={{ ...boxStyles, maxHeight: '600px', flexGrow: 1 }} id="schedule-table">
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="subtitle1">{t('Substitute Table')}</Typography>
                </Box>
                {loading ? (
                    <Box sx={{ ...innerBoxStyles }}>
                        <CircularProgress size={50} />
                    </Box>
                ) : (
                    <Box sx={{ ...innerBoxStyles, alignItems: "flex-start" }}>
                        <SubstituteTableList periods={periods} coveragePeriods={coveragePeriods} />
                    </Box>
                )}
            </Box>
        </BasePathProvider>
    );
}

export default SubstituteTable;